import { Select as SelectBase } from 'antd';
import { SelectProps } from 'antd/lib';
import { forwardRef } from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { BaseSelectRef } from 'rc-select/lib/BaseSelect';

interface IInputWrapProps extends SelectProps {
  field?: ControllerRenderProps<any, any>;
}

export const Select = forwardRef<BaseSelectRef, IInputWrapProps>(
  ({ className, options, field, ...props }, ref) => {
    return (
      <SelectBase ref={ref} className={className} {...field} {...props}>
        {(options ?? []).map((item) => {
          return (
            <SelectBase.Option key={item?.value} value={item?.value}>
              {item.label}
            </SelectBase.Option>
          );
        })}
      </SelectBase>
    );
  },
);
